module.exports = __webpack_public_path__ + "img/201510-1.131533c6.jpg";